import axios from 'axios';
import { inviteMemberAction } from './InviteMemberSlice';

const inviteMember = (token, identifier) => {
  return async (dispatch) => {
    const fetchData = async () => {
      const url = `${process.env.REACT_APP_DEV_URI}/user/family/invite`;
      const headers = { Authorization: `Bearer ${token}` };
      const response = await axios.post(url, { identifier }, { headers });
      return response;
    };
    try {
      const result = await fetchData();
      dispatch(inviteMemberAction.inviteMemberSuccess(result.data));
    } catch (e) {
      dispatch(inviteMemberAction.inviteMemberFailure(e.response?.data ?? e.message));
    }
  };
};

export default inviteMember;